module.exports = __webpack_public_path__ + "img/img_dmain2.4a5fe1a7.jpg";